(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  function initHeader() {
    qsa('[data-somnera-menu-toggle]').forEach((btn) => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      const header = btn.closest('[data-somnera-header]');
      const menu = header && qs('[data-somnera-mobile-menu]', header);
      if (!menu) return;
      btn.addEventListener('click', () => {
        const open = menu.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initGallery(root = document) {
    qsa('[data-somnera-product]', root).forEach((section) => {
      let main = qs('[data-somnera-main-image]', section);
      const stage = qs('[data-somnera-main-stage]', section);
      if (!main && !stage) return;
      qsa('[data-somnera-thumb]', section).forEach((thumb) => {
        if (thumb.dataset.bound) return;
        thumb.dataset.bound = '1';
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.image;
          if (!src) return;
          if (!main && stage) {
            stage.querySelector('[data-somnera-placeholder]')?.remove();
            main = document.createElement('img');
            main.className = 'somnera-product__main-image';
            main.dataset.somneraMainImage = '';
            stage.appendChild(main);
          }
          if (!main) return;
          main.src = src;
          main.removeAttribute('srcset');
          main.alt = thumb.dataset.alt || main.alt || '';
          qsa('[data-somnera-thumb]', section).forEach((b) => b.classList.toggle('is-active', b === thumb));
        });
      });
    });
  }

  function initBundles(root = document) {
    qsa('[data-somnera-product]', root).forEach((section) => {
      const cards = qsa('[data-somnera-pack]', section);
      const forms = qsa('[data-somnera-purchase-form]', section);
      if (!cards.length) return;

      const price = qs('[data-somnera-price]', section);
      const compare = qs('[data-somnera-compare]', section);
      let main = qs('[data-somnera-main-image]', section);
      const stage = qs('[data-somnera-main-stage]', section);

      const syncQty = (formWrap, value) => {
        if (!formWrap) return;
        const visible = qs('[data-somnera-qty-visible]', formWrap);
        const hidden = qs('[data-somnera-form-quantity]', formWrap);
        const next = Math.max(1, Number(value || 1));
        if (visible) visible.value = String(next);
        if (hidden) hidden.value = String(next);
      };

      const apply = (card, animate = true) => {
        if (!card || card.disabled) return;
        const pack = card.dataset.pack;

        cards.forEach((c) => {
          const active = c === card;
          c.classList.toggle('is-selected', active);
          c.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        forms.forEach((formWrap) => {
          const active = formWrap.dataset.pack === pack;
          formWrap.hidden = !active;
          if (active) syncQty(formWrap, 1);
        });

        if (price && card.dataset.price) price.textContent = card.dataset.price;
        if (compare) {
          compare.textContent = card.dataset.compare || '';
          compare.hidden = !card.dataset.compare;
        }

        qsa('[data-somnera-thumb]', section).forEach((thumb) => thumb.classList.remove('is-active'));

        if (stage && card.dataset.image) {
          stage.querySelector('[data-somnera-placeholder]')?.remove();
          if (!main) {
            main = document.createElement('img');
            main.className = 'somnera-product__main-image';
            main.dataset.somneraMainImage = '';
            stage.appendChild(main);
          }
          const swap = () => {
            main.src = card.dataset.image;
            main.removeAttribute('srcset');
            main.alt = card.dataset.alt || main.alt || '';
          };
          if (animate) {
            main.classList.add('is-swapping');
            setTimeout(() => {
              swap();
              main.classList.remove('is-swapping');
            }, 120);
          } else {
            swap();
          }
        }
      };

      cards.forEach((card) => {
        if (card.dataset.bound) return;
        card.dataset.bound = '1';
        card.addEventListener('click', (event) => {
          event.preventDefault();
          apply(card, true);
        });
      });

      forms.forEach((formWrap) => {
        const visible = qs('[data-somnera-qty-visible]', formWrap);
        const minus = qs('[data-somnera-qty-minus]', formWrap);
        const plus = qs('[data-somnera-qty-plus]', formWrap);

        if (visible && !visible.dataset.bound) {
          visible.dataset.bound = '1';
          visible.addEventListener('input', () => syncQty(formWrap, visible.value));
        }
        if (minus && visible && !minus.dataset.bound) {
          minus.dataset.bound = '1';
          minus.addEventListener('click', () => syncQty(formWrap, Number(visible.value || 1) - 1));
        }
        if (plus && visible && !plus.dataset.bound) {
          plus.dataset.bound = '1';
          plus.addEventListener('click', () => syncQty(formWrap, Number(visible.value || 1) + 1));
        }
      });

      const urlPack = new URLSearchParams(window.location.search).get('pack');
      const preferred = ['30', '60', '90'].includes(urlPack) ? urlPack : (section.dataset.defaultPack || '60');
      const initial = cards.find((c) => c.dataset.pack === preferred && !c.disabled) || cards.find((c) => !c.disabled);
      apply(initial, false);
    });
  }

  function initAll(root = document) {
    initHeader();
    initGallery(root);
    initBundles(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
